import React from 'react'
import { Link } from 'gatsby'
import CountUp from 'react-countup'

import * as styles from './index.module.css'

const AnimatedNumber = ({ cta }) => {
  const [isStarted, setIsStarted] = React.useState(false)

  let WrapperComponent = 'div'
  const linkProps = {}
  const { title, ctaUrl, ctaUrlInternal } = cta

  if (ctaUrl) {
    if (ctaUrlInternal) {
      WrapperComponent = Link
      linkProps.to = ctaUrl
    } else {
      WrapperComponent = 'a'
      linkProps.href = ctaUrl
    }
  }

  return (
    <WrapperComponent {...linkProps}>
      {title.split('').map((value, index) => {
        if (Number.isNaN(+value) && isStarted) {
          return (
            <span key={index} className={styles.title}>
              {value}
            </span>
          )
        }
        return (
          <CountUp
            key={index}
            className={styles.title}
            end={+value}
            duration={1}
            onStart={() => setIsStarted(true)}
          />
        )
      })}
    </WrapperComponent>
  )
}

const BigNumbers = ({ components, backgroundColor }) => {
  if (!components) return null
  return (
    <div className={styles.bigNumbersContainer} style={{ backgroundColor }}>
      <div className={styles.bigNumbersWrapper}>
        {components.map((bigNumberBlock) => (
          <div key={bigNumberBlock.id} className={styles.block}>
            <div className={styles.bigNumbersInnerWrapper}>
              <AnimatedNumber cta={bigNumberBlock} />
              <p className={styles.subtitle}>
                {bigNumberBlock.subtitle.subtitle}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BigNumbers
